import svg4everybody from 'svg4everybody'
import config from './config'
import { html } from './utils/environment'
// Dynamic imports for development mode only
let gridHelper;
(async () => {
    if (config.IS_DEV) {
        const gridHelperModule = await import('./utils/grid-helper')
        gridHelper = gridHelperModule?.gridHelper
    }
})();

export default async function () {
    /**
     * Use external SVG spritemaps
     */
    svg4everybody()

    /**
     * Add grid helper
     */
    gridHelper?.()

    /**
     * isMobile
     */
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
    window.isMobile = isMobile;

    if (window.isMobile) {
        html.classList.add('is-mobile')
    }

    /**
     * isTouchDevice
     */
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    window.isTouchDevice = isTouchDevice

    if (window.isMobile) {
        html.classList.add('is-touch-device')
    }

}
